/**
 * @engine/vfx - Operator Nodes
 *
 * Math, random, and utility nodes available in any context.
 */

import type { VFXNodeDefinition } from '../../types';
import { dataPort } from '../../types';

/**
 * Operator node definitions.
 */

export const TIME_NODES: readonly VFXNodeDefinition[] = [

  {
    id: 'vfx.operator.time',
    name: 'Time',
    category: 'utility',
    contexts: [],
    description: 'Get simulation time',
    color: '#9E9E9E',
    inputs: [],
    outputs: [
      dataPort('time', 'Time', 'float'),
      dataPort('deltaTime', 'Delta', 'float'),
    ],
    shader: {
      // The `deltaTime` output port shadows the env builtin of the same name,
      // so the delta is read straight from the module-scope uniforms binding.
      code: `time = simulationTime; deltaTime = uniforms.deltaTime;`,
    },
  },

  {
    id: 'vfx.operator.periodic_time',
    name: 'Loop Time',
    category: 'utility',
    contexts: [],
    description: 'Looping time value mapped to a range',
    color: '#9E9E9E',
    inputs: [
      dataPort('period', 'Period', 'float', { defaultValue: 5, range: { min: 0.001, max: 60 } }),
      dataPort('range', 'Range', 'vec2', { defaultValue: { x: 0, y: 1 } }),
    ],
    outputs: [
      dataPort('t', 'T', 'float'),
    ],
    shader: {
      code: `t = lerp(range.x, range.y, frac(simulationTime / period));`,
    },
  },
];
